import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { UnitTypeEnum } from "../../../../shared/Models/enums/UnitUnitTypeEnum";

@Injectable({
  providedIn: "root",
})
export class UnitSynchronizationService {
  insideUnitChanged: Subject<[string, UnitTypeEnum, number]> = new Subject<
    [string, UnitTypeEnum, number]
  >();
  outsideUnitChanged: Subject<any> = new Subject<any>();
}
